import {React, useState, useEffect} from "react";
import Footer2 from "./Footer2";
import Header from "./Header";
import HeaderInner from "./HeaderInner";
import HeaderLower from "./HeaderLower";
import "./Button.css";
import { Icon } from "@iconify/react";
import {FaCheckCircle } from "react-icons/fa";
// import assignmentCheck from "@iconify-icons/zmdi/assignment-check";
import { Link, Navigate , useNavigate} from "react-router-dom";
import StorageService from "../services/storage.service";
import LogService from "../services/log.service";
import secureLocalStorage from "react-secure-storage";
import { Helmet } from "react-helmet";
import Footer from "./Footer";

function TestOurTech_thankyou(props) {
  const TITLE = "Ashley TestRest NW | Thank You";
  const [website, setWebsite] = useState(window.location.href);
  // const [signoutTime, setSignoutTime] = useState(180000);
  const [signoutTime, setSignoutTime] = useState(900000);
  const navigate = useNavigate();
  StorageService.destroyThankStorage();

  
useEffect(() => {
    async function logCreate() {
      try {
        await LogService.createLog(website);
      } catch (e) {
        console.log(e);
      }
    }
    logCreate();
  }, [website]);

  useEffect(() => {
    function timeout() {
      setTimeout(function () {
        localStorage.setItem("returnpage", false);
        localStorage.removeItem("RegisterForm");
        localStorage.removeItem("TestOurTech_thankyou");
        window.location.replace("/");
        return false;
      }, signoutTime);
    }

    timeout();
  }, [signoutTime]);
  
//FIXME
  const isRegister = localStorage.getItem("isRegister");
  if (
    isRegister === "false" ||
    isRegister === null ||
    isRegister === undefined
  ) {
    return <Navigate to="/" />;
  }
  var registerform = secureLocalStorage.getItem("registerform");
  var RegisterObject = registerform ? JSON.parse(registerform) : false;
  if(typeof(RegisterObject) === "boolean") {
    return <Navigate to="/" />;
  } else {
    // let showroom = RegisterObject.showroom ? RegisterObject.showroom : false;
  }
  const myDestory = () => {
    localStorage.removeItem("return_page", false);
    localStorage.removeItem("isRegister");
    secureLocalStorage.removeItem("registerform");
    // window.location.replace("/");
  };
  // if(!RegisterObject.showroom){
  //   console.log("if")
    
  //   // console.log(RegisterObject.showroom)
  //   // navigate("/register");
  //   // return <Navigate to="/register" />;
  // } else {
  //   console.log("else")

  // }
  // if (localStorage.getItem("return_page") === "true") {
  //   return <Navigate to="/register/registration-thankyou" />;
  // }
  return (
    <>
     <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="container-fluid">
        <Header />
        {/* <HeaderInner/> */}
        {/* <HeaderLower /> */}
        <div className="white-box thank">
          <h1 className="text-center">Thank You! </h1>
          {/* <Icon icon={assignmentCheck} /> */}
          <FaCheckCircle/>
          <p style={{ fontFamily: 'Nimbus Sans'}}>
              You will receive an email with your unique code from our
              fulfillment center. Once you receive your email you will be given
              instructions on redeeming your Reward Card. For further
              information please call{" "}
              <Link to="tel:1-866-ELITE-21">1-866-ELITE-21</Link> or email us at{" "}
              <Link to="mailto:customercare@eliterewards.biz">
                customercare@eliterewards.biz
              </Link>{" "}
              and one of our customer service representatives will be happy to
              assist you.
            </p>
          <Link to={void 0} onClick={() => myDestory()} id="Thanku_Buttons" className="btn btn-md btn-primary2">
            Go Back
          </Link>
        </div>
      </div>
      {/* <Footer2 /> */}
      <Footer/>
    </>
  );
}
export default TestOurTech_thankyou;
